import ControlsChevronDown from "@casino/external/icons/ControlsChevronDown";
import ControlsChevronUp from "@casino/external/icons/ControlsChevronUp";
import type { CasinoGameConnectionSorter } from "@workspace/casino_core/schema";
import ToggleButton from "./ToggleButton";

type Props = {
  item: {
    value: keyof CasinoGameConnectionSorter;
    label: string;
  };
  current: SelectedSort;
  onSortSelect: (value: keyof CasinoGameConnectionSorter) => void;
  isBitcasino: boolean;
};

const SortItem: FC<Props> = ({ item, current, onSortSelect, isBitcasino }) => {
  const selected = item.value === current.name;
  const desc = current.value === -1;
  return (
    <ToggleButton
      selected={selected}
      onClick={() => onSortSelect(item.value)}
      isBitcasino={isBitcasino}
    >
      {selected &&
        (desc ? (
          <div className="m-2 stroke-[4px] w-4 h-4">
            <ControlsChevronDown />
          </div>
        ) : (
          <div className="m-2 stroke-[4px] w-4 h-4">
            <ControlsChevronUp />
          </div>
        ))}
      <span className="m-2 text-sm/6">{item.label}</span>
    </ToggleButton>
  );
};

export default SortItem;
